<template>
  <div class="normalpaper">
    <div class="header">
      <div class="contain_main">
        <div class="logo">
          <img src="@/assets/header/logo.png" alt>
        </div>
        <div>
          <div class="button" @click="stock">题库导入</div>
          <div class="button" @click="issuestock=false;exceladd=true">Excel导入</div>
          <!-- <div class="button" @click="delSimilar">试题去重</div> -->
          <div class="button" @click="scan">预览</div>
          <div class="button" @click="addpaper">保存</div>
          <div class="button" @click="cancle">取消</div>
        </div>
      </div>
    </div>
    <div class="headernull"></div>
    <div class="contain_main content">
      <div class="left">
        <div @click="make(1)">单选题</div>
        <div @click="make(2)">多选题</div>
        <div @click="make(4)">填空题</div>
        <div @click="make(3)">判断题</div>
        <div @click="make(5)">问答题</div>
        <div @click="make(0)">段落说明</div>
      </div>
      <div class="right">
        <div class="title">
          <span>
            试卷名称 ：
            <i-input type="text" style="width:300px" v-model="data.eptitle" placeholder="请输入试卷名称"></i-input>
          </span>
          <span>
            多选题少选得分:
            <i-Switch size="large" v-model="epdiff">
              <span slot="open">ON</span>
              <span slot="close">OFF</span>
            </i-Switch>
          </span>
        </div>
        <div class="title">
          <span>
            试题数量 ：
            <i-input type="text" style="width:200px" disabled v-model="data.epcount"></i-input>
          </span>
          <span>
            试题总分 ：
            <i-input type="text" style="width:200px" disabled v-model="data.epscore"></i-input>
          </span>
          <span>是否有主观：{{data.epitem==0?"否":"是"}}</span>
        </div>
        <makeissue
          v-for="(item,index) in list"
          :key="item.questionid"
          :order="(index+1)"
          @exit="exit"
          @complated="edit"
          @delitem="delitem"
          @moveupitem="moveupitem"
          @movedownitem="movedownitem"
          @isedit="isedit"
          :message="item"
        />
        <div style="height:200px;"></div>
      </div>
    </div>
    <exceladd v-if="exceladd" @sure="sure" @close="close"></exceladd>
    <issuestock @sure="sure" :haslist="haslist" v-if="issuestock" @close="close"></issuestock>
  </div>
</template>
<script>
import makeissue from "../../components/makeissue";
import exceladd from "../../components/exceladd";
import issuestock from "../../components/issuestock";
import {
  ExamPaper_add,
  ExamPaper_getInfo1,
  ExamPaper_update
} from "../../assets/js/api.js";
import { setTimeout } from 'timers';
export default {
  data() {
    return {
      list: [],
      exceladd: false,
      issuestock: false,
      epdiff: false,
      data: {
        epscore: "",
        epcount: "",
        epitem: 0,
        eptitle: "",
        epquestions: ""
      },
      haslist: [],
      loaddata: 0
    };
  },
  mounted() {
    if (this.$route.query.eptitle) {
      this.data.eptitle = this.$route.query.eptitle;
    }
    if (
      (this.$route.query.editid || this.$route.query.copyid) &&
      !this.$route.query.scan
    ) {
      this.getdata();
      // 添加获取标签
      // var query = { ...this.$route.query };
      // query.scan = true;
      // this.$router.push({
      //   path: "/manage/normalpaper",
      //   query: query
      // });
    } else {
      if (window.sessionStorage.getItem("normalpaperlist")) {
        this.list = JSON.parse(
          window.sessionStorage.getItem("normalpaperlist")
        );
      }
      if (this.list instanceof Array) {
        this.list = this.list.map(item => {
          delete item.qbtitle;
          item.isedit = false;
          return item;
        });
        this.numberScore();
      } else {
        this.list = [];
      }
    }
  },
  components: {
    makeissue,
    exceladd,
    issuestock
  },
  methods: {
    //题库导入
    stock() {
      if (this.checkisedit()) return;
      this.exceladd = false;
      this.issuestock = true;
      this.haslist = this.list.map(item => item.questionid);
    },
    //取消设定函数
    cancle() {
      // this.$router.go(-1);
      window.sessionStorage.removeItem("normalpaperlist");
      this.$router.push("/manage/publiclist");
    },
    // 编辑试题部分
    getdata() {
      ExamPaper_getInfo1({
        epid: this.$route.query.editid || this.$route.query.copyid
      }).then(res => {
        if (res.data.code == 200) {
          this.list = [];
          this.loadact(res.data.data.epquestions)
          this.data.eptitle = res.data.data.eptitle;
          this.epdiff = res.data.data.epdiff == 1 ? true : false;
          this.data.epitem = res.data.data.epitem;
          
        }
      });
    },
    //大题量下分段加载数据-------性能优化
    loadact(data) {
      var t = data.length;
      if ((30 * this.loaddata) < t) {
        this.list=this.list.concat(data.slice( 30*this.loaddata, 30 * (this.loaddata + 1)));
        setTimeout(() => {
          this.loadact(data);
        },400);
        this.loaddata +=1
      }else{
        this.numberScore();
        this.setlist();
        this.loaddata = 0
      }
    },
    // 添加试题部分
    close() {
      this.exceladd = false;
      this.issuestock = false;
    },
    exit(index) {
      if (!JSON.parse(window.sessionStorage.getItem("normalpaperlist"))) {
        this.list = [];
      } else {
        this.list = JSON.parse(
          window.sessionStorage.getItem("normalpaperlist")
        );
      }
      this.list = this.list.map(item => {
        delete item.hasedit;
        item.isedit = false;
        return item;
      });
    },
    delitem(data) {
      this.list.splice(data, 1);
      this.numberScore();
      this.setlist();
    },
    moveupitem(data) {
      if (data == 0) {
        this.errorPlus("已经在最顶部,无法上移!");
        return;
      }
      this.list[data - 1] = this.list.splice(data, 1, this.list[data - 1])[0];
      this.setlist();
    },
    movedownitem(data) {
      if (data == this.list.length - 1) {
        this.errorPlus("已经在最底部,无法下移!");
        return;
      }
      this.$set(
        this.list,
        data,
        this.list.splice(data + 1, 1, this.list[data])[0]
      );
      this.setlist();
    },
    isedit(index, isedit) {
      this.list = this.list.map(item => {
        item.hasedit = true;
        return item;
      });
      this.list[index].isedit = true;
    },
    checkisedit() {
      if (this.list.some(item => item.isedit)) {
        this.errorPlus("有题目在编辑状态,请完成编辑后操作!");
        return true;
      } else {
        return false;
      }
    },
    make(data) {
      if (this.checkisedit()) return;
      this.list.push({
        questiontype: data,
        isedit: true
      });
      this.list = this.list.map(item => {
        item.hasedit = true;
        return item;
      });
      this.$nextTick(function() {
        window.scrollTo(0, document.documentElement.scrollHeight);
      });
    },
    numberScore() {
      this.data.epcount = this.list.length;
      this.data.epscore = this.list.reduce((pre, cur) => {
        return pre + Number(cur.questionscore);
      }, 0);
      this.data.epitem = this.list.some(item => {
        return item.questionitem == 1;
      });
    },
    edit(data, index) {
      this.list = this.list.map(item => {
        delete item.hasedit;
        item.isedit = false;
        return item;
      });
      this.list[index - 1] = data;
      this.numberScore();
      window.sessionStorage.setItem(
        "normalpaperlist",
        JSON.stringify(this.list)
      );
    },
    sure(data) {
      this.list = this.list.concat(data);
      this.list = this.list.map(item => {
        delete item.qbtitle;
        item.isedit = false;
        return item;
      });
      this.numberScore();
      this.setlist();
      // this.close();
    },
    setlist() {
      window.sessionStorage.setItem(
        "normalpaperlist",
        JSON.stringify(this.list)
      );
    },
    addpaper() {
      if (this.checkisedit()) return;
      if (!this.list.length) {
        this.errorPlus("请编辑或导入试题");
        return;
      }
      if (!this.data.eptitle) {
        this.errorPlus("试卷标题不能为空");
        return;
      }
      if (this.data.eptitle && this.data.eptitle.length > 100) {
        this.errorPlus("试卷标题不能超过100字");
        return;
      }
      if (!window.sessionStorage.getItem("normalpaperlist")) {
        this.errorPlus("请完成题目编辑或添加后保存试卷");
        return;
      }
      // if(this.checkSimilar){
      //   this.errorPlus("有重复题目，请点击“试题去重”按钮后提交");
      //   return;
      // }
      this.data.epquestions = this.list;
      this.data.epcount = this.list.length;
      this.data.epscore = this.list.reduce((pre, cur) => {
        return pre + Number(cur.questionscore);
      }, 0);
      this.data.epitem =
        this.list.some(item => {
          return item.questionitem == 1;
        }) - 0;
      this.data.epdiff = this.epdiff - 0;
      if (this.$route.query.editid) {
        this.data.epid = this.$route.query.editid;
        ExamPaper_update(this.data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "编辑保存成功！" });
            this.$router.push("/manage/publiclist");
            window.sessionStorage.removeItem("normalpaperlist");
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      } else {
        ExamPaper_add(this.data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "保存成功！" });
            this.$router.push("/manage/publiclist");
            window.sessionStorage.removeItem("normalpaperlist");
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      }
    },
    scan() {
      var data = {
        scan: true
      };
      if (this.$route.query.editid) {
        data.editid = this.$route.query.editid;
      }
      if (this.data.eptitle) {
        data.eptitle = this.data.eptitle;
      }
      this.$router.push({
        path: "/manage/normalpaper",
        query: data
      });
      if (this.checkisedit()) return;
      if (!this.list.length) {
        this.errorPlus("请编辑或导入试题");
        return;
      }
      this.data.epquestions = [{ title: "试题", questions: this.list }];
      this.$router.push({ name: "scanpaper", params: { message: this.data } });
    }
    // checkSimilar(){
    //   var set = new Set(this.list.map(item=>{return item.questionid}))
    //   var length = set.size
    //   if(length<this.length.length){
    //     return true
    //   }else{
    //    return false
    //   }
    // },
    // delSimilar() {
    //   var map = new Map();
    //   var length1 = this.list.length;
    //   if (length1 > 0) {
    //     this.list.forEach(item => {
    //       map.set(item.questionid, item);
    //     });
    //     this.list = [...map.values()];
    //     var length2 = this.list.length;
    //     if (length2 == length1) {
    //       this.$Notice.success({ title: "信息提示", desc: "没有重复的题目！" });
    //     } else {
    //       this.$Notice.success({
    //         title: "信息提示",
    //         desc:
    //           "已经去除" +
    //           (length1 - length2) +
    //           "道重复的题目\n请注意题数和总分变化"
    //       });
    //     }
    //     this.setlist();
    //   } else {
    //     this.errorPlus("请编辑试卷后再进行检测去重！");
    //   }
    //   this.numberScore()
    // }
  }
};
</script>
<style lang="css" scoped>
.normalpaper {
  position: absolute;
  width: 100%;
  height: 100%;
}
.header {
  width: 100%;
  height: 0.8rem;
  text-align: left;
  border-bottom: #e8e9ee 1px solid;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: #fff;
}
.header .contain_main {
  display: flex;
  justify-content: space-between;
  line-height: 0.8rem;
}
.logo {
  width: 1.84rem;
  height: 0.4rem;
  line-height: 0.4rem;
  margin-top: 0.2rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.15rem;
}
.headernull {
  height: 0.8rem;
}
.content {
  /* display: flex;
  justify-content: space-between; */
}
.left {
  width: 1rem;
  position: fixed;
  top: 0.8rem;
}
.right {
  width: 9rem;
  height: 100%;
  float: right;
}
.left > div {
  height: 0.3rem;
  width: 1rem;
  margin: 0.1rem auto;
  color: #7b8b9f;
  line-height: 0.3rem;
  border-radius: 0.15rem;
  font-size: 0.16rem;
  background: #e9effa62;
  cursor: pointer;
}
.left > div:hover {
  background: #ccddff;
  color: #474dff;
}
.title {
  text-align: left;
  margin: 20px;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/pages/namnege/normalpaper.vue